// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"fcac4bed","703":"256746e9","787":"5d1816ba"}[chunkId] + ".chunk.js";
};